<template>
<div class="news">
     <div class="banner">
     <div class="slg"> <p class="slg_title1">新闻中心</p>
       <p class="slg_title2">诚信为基共筑未来 贴心服务助力企业发展</p></div>

   </div>
  <div class="bottom">
            <ul>
<!--                <li class="clearfix wow fadeInUp animated" data-wow-duration=".9s" data-wow-delay=".2s" style="visibility: visible; animation-duration: 0.9s; animation-delay: 0.2s; animation-name: fadeInUp;">-->
<!--                    <a href="/article/44">-->
<!--                        <div class="img">-->
<!--                            <img src="../../assets/img/news/75a1.jpg" alt="">-->
<!--                        </div>-->
<!--                        </a><div class="box"><a href="/new2024101701">-->
<!--                            <h5>中国人民银行成立75周年</h5>-->
<!--                            <span>时间：2024-10-01 16:59</span>-->
<!--                            <p>来源：中国人民银行</p>-->
<!--                            </a><a class="ljgd" href="/new2024101701">了解详情 &gt;</a>-->
<!--                        </div>-->

<!--                </li>-->
                <li class="clearfix wow fadeInUp animated" data-wow-duration=".9s" data-wow-delay=".2s" style="visibility: visible; animation-duration: 0.9s; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <a href="/article/43">
                        <div class="img">
                            <img src="../../assets/img/news/gjgs1.png" alt="">
                        </div>
                        </a><div class="box"><a href="/news2024101702">
                            <h5>北京冠捷时速信用管理有限责任公司为信用中国公示第一批可出具信用报告的信用服务机构</h5>
                            <span>时间：2024-10-01 01:25</span>
                            <p>北京冠捷时速信用管理有限责任公司为信用中国公示第一批可出具信用报告的信用服务机构</p>
                            </a><a class="ljgd" href="/news2024101702">了解详情 &gt;</a>
                        </div>

                </li>
<!--                <li class="clearfix wow fadeInUp animated" data-wow-duration=".9s" data-wow-delay=".2s" style="visibility: visible; animation-duration: 0.9s; animation-delay: 0.2s; animation-name: fadeInUp;">-->
<!--                    <a href="/article/42">-->
<!--                        <div class="img">-->
<!--                            <img src="../../assets/img/news/b300d35606d757f32947981f1a833c56_d8b6577172f64be3a7fdb9ba2652f66a.jpg" alt="">-->
<!--                        </div>-->
<!--                        </a><div class="box"><a href="/news2024101703">-->
<!--                            <h5>中国人民银行营业管理部关于公布北京地区完成备案办理的企业征信机构名单的公告</h5>-->
<!--                            <span>时间：2024-10-01 22:24</span>-->
<!--                            <p>中国人民银行营业管理部关于公布北京地区完成备案办理的企业征信机构名单的公告</p>-->
<!--                            </a><a class="ljgd" href="/news2024101703">了解详情 &gt;</a>-->
<!--                        </div>-->

<!--                </li>-->
            </ul>
        </div>
</div>
</template>

<script>
export default {
  name: 'list'
}
</script>

<style scoped>
.news .bottom {
    max-width: 1420px;
    margin: 0 auto;
    background: #fff;
    padding: 0 10px;
    box-sizing: border-box;
    min-height: 10vh;
}
  ul, ol, dl {
    list-style-type: none;
}
  .news .bottom ul li {
    padding: 24px 0;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 40px;
}
  a:visited {
    color: #000;
}
  .news .bottom ul li .box {
    width: 70%;
    float: right;
    background: #f6f6f6;
    padding: 66px 60px 50px 70px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
}
  .cl:after, .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
  .news .bottom ul li .box h5 {
    line-height: 34px;
    border: 1px solid #535353;
    line-height: 32px;
    border-left: 0;
    border-right: 0;
    font-size: 20px;
    color: #333;
    display: inline-block;
    height: 34px;
    max-width: 100%;
    overflow: hidden;
    font-weight: 400;
}
  .news .bottom ul li .box span {
    margin-top: 8px;
    display: block;
    line-height: 38px;
    height: 38px;
    overflow: hidden;
}
  .news .bottom ul li .box p {
    line-height: 28px;
    height: 56px;
    overflow: hidden;
    font-size: 14px;
    color: #666;
}
  .news .bottom ul li .box .ljgd {
    margin-top: 20px;
    line-height: 28px;
    display: block;
    text-align: right;
    font-size: 14px;
    color: #838383;
}
  .news .bottom ul li .img {
    position: absolute;
    left: 0;
    top: 0;
    width: 33%;
    height: 100%;
    background-size: cover !important;
}
  .news .bottom ul li .img img {
    width: 100%;
    height: 100%;
}
  .news .bottom ul li:hover .box {
    background: #239dff;
    color: #ffffff;
}
  .news .bottom ul li:hover .box h5 {
    border: 1px solid #fff;
    color: #fff;
    border-left: 0;
    border-right: 0;
}
  .news .bottom ul li:hover .box span {
    color: #fff;
}
  .news .bottom ul li:hover .box p {
    color: #fff;
}
  .news .bottom ul li:hover .box .ljgd {
    color: #fff;
}
  .banner {
    background-image: url(../../assets/img/bg1.jpg);
    background-size: cover;
    background-position: center;
    height: 560px;
    overflow: hidden;
}
    .slg{
    width: 1200px;
    margin: auto;
    padding-top: 200px;
  }
    .slg_title1{
    font-size: 50px;
    color: #d46700;
    margin: 0px 0px 0px 0px;
  }
    .slg_title2{
      margin: 20px 0px 0px 0px;
    font-size: 40px;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/list.vue